import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../api/axios";

const DEFAULT_GUIDE = [
  {
    stepNumber: 1,
    sectionTitle: "What is this QR code sticker?",
    sectionTitleHindi: "\u092f\u0939 QR \u0915\u094b\u0921 \u0938\u094d\u091f\u093f\u0915\u0930 \u0915\u094d\u092f\u093e \u0939\u0948?",
    content: "This is a small waterproof sticker with a unique QR code. When someone scans it with any mobile phone, they instantly see your emergency information.",
    contentHindi: "\u092f\u0939 \u090f\u0915 \u091b\u094b\u091f\u093e \u0935\u093e\u091f\u0930\u092a\u094d\u0930\u0942\u092b \u0938\u094d\u091f\u093f\u0915\u0930 \u0939\u0948 \u091c\u093f\u0938 \u092a\u0930 \u090f\u0915 \u0905\u0928\u094b\u0916\u093e QR \u0915\u094b\u0921 \u0939\u0948\u0964 \u091c\u092c \u0915\u094b\u0908 \u0907\u0938\u0947 \u0915\u093f\u0938\u0940 \u092d\u0940 \u092e\u094b\u092c\u093e\u0907\u0932 \u092b\u094b\u0928 \u0938\u0947 \u0938\u094d\u0915\u0948\u0928 \u0915\u0930\u0924\u093e \u0939\u0948, \u0924\u094b \u0909\u0928\u094d\u0939\u0947\u0902 \u0924\u0941\u0930\u0902\u0924 \u0906\u092a\u0915\u0940 \u0906\u092a\u093e\u0924\u0915\u093e\u0932\u0940\u0928 \u091c\u093e\u0928\u0915\u093e\u0930\u0940 \u0926\u093f\u0916\u0924\u0940 \u0939\u0948\u0964",
    language: "both",
  },
  {
    stepNumber: 2,
    sectionTitle: "How to scan the QR code",
    sectionTitleHindi: "QR \u0915\u094b\u0921 \u0915\u0948\u0938\u0947 \u0938\u094d\u0915\u0948\u0928 \u0915\u0930\u0947\u0902",
    content: "Open the camera app on any Android or iPhone and point it at the QR code. A link will appear on screen — tap it to see emergency information. No app needed.",
    contentHindi: "\u0915\u093f\u0938\u0940 \u092d\u0940 Android \u092f\u093e iPhone \u092a\u0930 \u0915\u0948\u092e\u0930\u093e \u090f\u092a \u0916\u094b\u0932\u0947\u0902 \u0914\u0930 QR \u0915\u094b\u0921 \u092a\u0930 \u092a\u0949\u0907\u0902\u091f \u0915\u0930\u0947\u0902\u0964 \u0938\u094d\u0915\u094d\u0930\u0940\u0928 \u092a\u0930 \u090f\u0915 \u0932\u093f\u0902\u0915 \u0926\u093f\u0916\u0947\u0917\u093e \u2014 \u0906\u092a\u093e\u0924\u0915\u093e\u0932\u0940\u0928 \u091c\u093e\u0928\u0915\u093e\u0930\u0940 \u0926\u0947\u0916\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u0909\u0938 \u092a\u0930 \u091f\u0948\u092a \u0915\u0930\u0947\u0902\u0964 \u0915\u094b\u0908 \u090f\u092a \u0915\u0940 \u091c\u0930\u0942\u0930\u0924 \u0928\u0939\u0940\u0902\u0964",
    language: "both",
  },
  {
    stepNumber: 3,
    sectionTitle: "How to set up your information",
    sectionTitleHindi: "\u0905\u092a\u0928\u0940 \u091c\u093e\u0928\u0915\u093e\u0930\u0940 \u0915\u0948\u0938\u0947 \u0938\u0947\u091f \u0915\u0930\u0947\u0902",
    content: "Scan your sticker and tap 'Set Up'. Enter your name, phone number, and a password. Then add your emergency details: blood group, doctor's name, medicines you take, and emergency contact numbers.",
    contentHindi: "\u0905\u092a\u0928\u093e \u0938\u094d\u091f\u093f\u0915\u0930 \u0938\u094d\u0915\u0948\u0928 \u0915\u0930\u0947\u0902 \u0914\u0930 '\u0938\u0947\u091f \u0905\u092a' \u092a\u0930 \u091f\u0948\u092a \u0915\u0930\u0947\u0902\u0964 \u0905\u092a\u0928\u093e \u0928\u093e\u092e, \u092b\u094b\u0928 \u0928\u0902\u092c\u0930 \u0914\u0930 \u090f\u0915 \u092a\u093e\u0938\u0935\u0930\u094d\u0921 \u0921\u093e\u0932\u0947\u0902\u0964 \u092b\u093f\u0930 \u0905\u092a\u0928\u0940 \u0906\u092a\u093e\u0924\u0915\u093e\u0932\u0940\u0928 \u091c\u093e\u0928\u0915\u093e\u0930\u0940 \u091c\u094b\u0921\u093c\u0947\u0902: \u092c\u094d\u0932\u0921 \u0917\u094d\u0930\u0941\u092a, \u0921\u0949\u0915\u094d\u091f\u0930 \u0915\u093e \u0928\u093e\u092e, \u0906\u092a \u091c\u094b \u0926\u0935\u093e\u0907\u092f\u093e\u0902 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902, \u0914\u0930 \u0906\u092a\u093e\u0924\u0915\u093e\u0932\u0940\u0928 \u0938\u0902\u092a\u0930\u094d\u0915 \u0928\u0902\u092c\u0930\u0964",
    language: "both",
  },
  {
    stepNumber: 4,
    sectionTitle: "What happens in an emergency",
    sectionTitleHindi: "\u0906\u092a\u093e\u0924\u0915\u093e\u0932 \u092e\u0947\u0902 \u0915\u094d\u092f\u093e \u0939\u094b\u0924\u093e \u0939\u0948",
    content: "If you are injured or unconscious, any passerby or paramedic can scan your sticker and immediately see your blood group, emergency contacts, and medical conditions.",
    contentHindi: "\u0905\u0917\u0930 \u0906\u092a \u0918\u093e\u092f\u0932 \u0939\u0948\u0902 \u092f\u093e \u092c\u0947\u0939\u094b\u0936 \u0939\u0948\u0902, \u0924\u094b \u0915\u094b\u0908 \u092d\u0940 \u0930\u093e\u0939\u0917\u0940\u0930 \u092f\u093e \u092a\u0948\u0930\u093e\u092e\u0947\u0921\u093f\u0915 \u0906\u092a\u0915\u093e \u0938\u094d\u091f\u093f\u0915\u0930 \u0938\u094d\u0915\u0948\u0928 \u0915\u0930 \u0938\u0915\u0924\u093e \u0939\u0948 \u0914\u0930 \u0924\u0941\u0930\u0902\u0924 \u0906\u092a\u0915\u093e \u092c\u094d\u0932\u0921 \u0917\u094d\u0930\u0941\u092a, \u0906\u092a\u093e\u0924\u0915\u093e\u0932\u0940\u0928 \u0938\u0902\u092a\u0930\u094d\u0915 \u0914\u0930 \u092c\u0940\u092e\u093e\u0930\u093f\u092f\u093e\u0902 \u0926\u0947\u0916 \u0938\u0915\u0924\u093e \u0939\u0948\u0964",
    language: "both",
  },
  {
    stepNumber: 5,
    sectionTitle: "Suggested information to add",
    sectionTitleHindi: "\u091c\u094b\u0921\u093c\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u0938\u0941\u091d\u093e\u0908 \u0917\u0908 \u091c\u093e\u0928\u0915\u093e\u0930\u0940",
    content: "Blood group, doctor's name and phone number, nearest hospital name, medicines you take daily, known allergies, emergency contact (family member).",
    contentHindi: "\u092c\u094d\u0932\u0921 \u0917\u094d\u0930\u0941\u092a, \u0921\u0949\u0915\u094d\u091f\u0930 \u0915\u093e \u0928\u093e\u092e \u0914\u0930 \u092b\u094b\u0928 \u0928\u0902\u092c\u0930, \u0928\u091c\u093c\u0926\u0940\u0915\u0940 \u0905\u0938\u094d\u092a\u0924\u093e\u0932 \u0915\u093e \u0928\u093e\u092e, \u0930\u094b\u091c\u093c \u0932\u0947\u0928\u0947 \u0935\u093e\u0932\u0940 \u0926\u0935\u093e\u0907\u092f\u093e\u0902, \u091c\u094d\u091e\u093e\u0924 \u090f\u0932\u0930\u094d\u091c\u0940, \u0906\u092a\u093e\u0924\u0915\u093e\u0932\u0940\u0928 \u0938\u0902\u092a\u0930\u094d\u0915 (\u092a\u0930\u093f\u0935\u093e\u0930 \u0915\u093e \u0938\u0926\u0938\u094d\u092f)\u0964",
    language: "both",
  },
];

const GuidePage = () => {
  const [guide, setGuide] = useState(DEFAULT_GUIDE);
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState("both");

  useEffect(() => {
    api
      .get(`/public/guide?lang=${lang}`)
      .then((res) => {
        const data = res.data?.guide;
        if (Array.isArray(data) && data.length > 0) {
          setGuide(data);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [lang]);

  const handlePrint = () => {
    window.print();
  };

  const shareOnWhatsApp = () => {
    const url = encodeURIComponent(window.location.href);
    const message = encodeURIComponent("Emergency QR Sticker guide - how to set up and use your sticker: ");
    window.open(`https://wa.me/?text=${message}${url}`, "_blank");
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#fff", fontFamily: "'Segoe UI', sans-serif" }}>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { font-size: 14pt; }
          .guide-step { page-break-inside: avoid; }
        }
      `}</style>

      <div className="no-print" style={{ backgroundColor: "#dc2626", color: "white", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "12px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Link to="/" style={{ color: "white", textDecoration: "none", fontSize: "14px", fontWeight: "600" }}>
            ← Back
          </Link>
          <h1 style={{ margin: 0, fontSize: "20px", fontWeight: "800" }}>Emergency QR Sticker Guide</h1>
        </div>
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <select
            value={lang}
            onChange={(e) => setLang(e.target.value)}
            style={{ padding: "8px 12px", borderRadius: "8px", border: "none", fontSize: "14px", fontWeight: "600", cursor: "pointer" }}
          >
            <option value="both">English + Hindi</option>
            <option value="english">English Only</option>
            <option value="hindi">Hindi Only</option>
          </select>
          <button
            onClick={shareOnWhatsApp}
            style={{ backgroundColor: "#25D366", color: "white", border: "none", padding: "8px 16px", borderRadius: "8px", fontSize: "14px", fontWeight: "600", cursor: "pointer" }}
          >
            Share on WhatsApp
          </button>
          <button
            onClick={handlePrint}
            style={{ backgroundColor: "rgba(255,255,255,0.2)", color: "white", border: "2px solid rgba(255,255,255,0.4)", padding: "8px 16px", borderRadius: "8px", fontSize: "14px", fontWeight: "600", cursor: "pointer" }}
          >
            Download PDF
          </button>
        </div>
      </div>

      <div style={{ maxWidth: "800px", margin: "0 auto", padding: "40px 24px" }}>
        <div style={{ textAlign: "center", marginBottom: "48px" }}>
          <div style={{ fontSize: "64px", marginBottom: "16px" }}>🆘</div>
          <h1 style={{ fontSize: "32px", fontWeight: "900", color: "#111827", marginBottom: "8px" }}>
            Emergency QR Sticker Guide
          </h1>
          <p style={{ fontSize: "16px", color: "#6b7280" }}>
            How to set up and use your emergency QR code sticker
          </p>
          <p style={{ fontSize: "14px", color: "#9ca3af", marginTop: "4px" }}>
            आपातकालीन QR कोड स्टिकर का उपयोग कैसे करें
          </p>
        </div>

        {loading ? (
          <div style={{ textAlign: "center", padding: "40px", color: "#6b7280" }}>Loading guide...</div>
        ) : (
          <div>
            {guide.map((step, idx) => (
              <div
                key={step._id || idx}
                className="guide-step"
                style={{
                  marginBottom: "40px",
                  padding: "32px",
                  backgroundColor: "#f9fafb",
                  borderRadius: "16px",
                  border: "2px solid #e5e7eb",
                  borderLeft: "6px solid #dc2626",
                }}
              >
                <div style={{ display: "flex", alignItems: "flex-start", gap: "20px" }}>
                  <div
                    style={{
                      minWidth: "52px",
                      height: "52px",
                      backgroundColor: "#dc2626",
                      color: "white",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "22px",
                      fontWeight: "900",
                      flexShrink: 0,
                    }}
                  >
                    {step.stepNumber}
                  </div>
                  <div style={{ flex: 1 }}>
                    <h2 style={{ fontSize: "22px", fontWeight: "800", color: "#111827", marginBottom: "4px", marginTop: 0 }}>
                      {lang === "hindi" && step.sectionTitleHindi ? step.sectionTitleHindi : step.sectionTitle}
                    </h2>
                    {lang === "both" && step.sectionTitleHindi && (
                      <p style={{ fontSize: "16px", color: "#dc2626", fontWeight: "600", marginBottom: "12px", marginTop: 0 }}>
                        {step.sectionTitleHindi}
                      </p>
                    )}
                    <p style={{ fontSize: "17px", color: "#374151", lineHeight: "1.7", marginBottom: lang === "both" && step.contentHindi ? "16px" : 0, marginTop: 0 }}>
                      {lang === "hindi" && step.contentHindi ? step.contentHindi : step.content}
                    </p>
                    {lang === "both" && step.contentHindi && (
                      <p style={{ fontSize: "16px", color: "#4b5563", lineHeight: "1.7", marginBottom: 0, marginTop: 0, borderTop: "1px solid #e5e7eb", paddingTop: "12px" }}>
                        {step.contentHindi}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={{ marginTop: "48px", padding: "32px", backgroundColor: "#fef2f2", borderRadius: "16px", border: "2px solid #fecaca", textAlign: "center" }}>
          <p style={{ fontSize: "18px", fontWeight: "800", color: "#dc2626", marginBottom: "8px" }}>
            Get your QR sticker for just Rs. 99
          </p>
          <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "16px" }}>
            Protect yourself and your family today
          </p>
          <Link to="/">
            <button style={{ backgroundColor: "#dc2626", color: "white", border: "none", padding: "14px 32px", borderRadius: "10px", fontSize: "16px", fontWeight: "700", cursor: "pointer" }}>
              Order Now
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GuidePage;
